import { apiRequest } from '@/config/axios/axios'

export const fetchProduct = (code, segment) => {
  return apiRequest.get(`products/${code}?segmentGroup=${segment}`)
}
